import FuseLoading from '@fuse/core/FuseLoading';
import FuseErrorBoundary from '@fuse/core/FuseErrorBoundary';
import PropTypes from 'prop-types';
import { Suspense } from 'react';

/**
 * React Suspense defaults
 * For to Avoid Repetition
 *
 * PGSS-5456: the boundary sits OUTSIDE Suspense deliberately. Suspense catches a suspension, not
 * a rejection -- when a lazy route chunk fails to load, `React.lazy` throws the rejection straight
 * past it. With no boundary above, that reached the root and unmounted the whole app: a blank
 * screen. Wrapping here covers the route content in all three layouts from one place.
 */ function FuseSuspense(props) {
  return (
    <FuseErrorBoundary>
      <Suspense fallback={<FuseLoading {...props.loadingProps} />}>{props.children}</Suspense>
    </FuseErrorBoundary>
  );
}

FuseSuspense.propTypes = {
  loadingProps: PropTypes.object,
};

FuseSuspense.defaultProps = {
  loadingProps: {
    delay: 0,
  },
};

export default FuseSuspense;
